import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ConditionalLink } from 'components/ConditionalLink';
import Image from 'assets/images/not-paid.webp';
import { getCreateListingRoute } from 'utils';
import { ListingType } from 'models/Listing';
import ResolveImage from 'components/ResolveImage';

import './NotPaidDeal.styles.scss';

type NotPaidDealProps = {
  className?: string;
  dealRoomId: string;
  listingId: string;
  listingType: ListingType;
  isDisabled?: boolean;
};

const NotPaidDeal: React.FC<NotPaidDealProps> = (props) => {
  const { className, dealRoomId, listingType, listingId, isDisabled } = props;

  const classes = classNames('not-paid-deal', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <ResolveImage src={Image} asIllustration alt="Deal is not paid." />

      <p>{t('notPaidDealTitle')}</p>
      <p>{t('notPaidDealDescription')}</p>

      <ConditionalLink
        isDisabled={isDisabled}
        disabledClassName="ncoded-button--solid"
        to={getCreateListingRoute(dealRoomId, listingId, listingType)}
      >
        {t('draftListing')}
      </ConditionalLink>
    </div>
  );
};

export default NotPaidDeal;
